import { FlexBox } from 'shared/components/Base/FlexBox'
import styled from 'styled-components'

export const IssueGrid = styled.div`
  display: grid;
  grid-template-columns: 237px 364px 448px;
  gap: 67px;
`

export const LabelValueGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 8px;
`

export const RadioButtonGroupWrap = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`

export const StyledFlexBox = styled(FlexBox)`
  margin: 20px;
`

export const StyledIssueSection = styled(FlexBox)<{ isLast?: boolean }>`
  ${({ isLast }) =>
    !isLast &&
    `
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #e5e5e5;`}
`
